
import { Component, Prop, Vue } from 'vue-property-decorator'
import { ISearchLog } from '@/types/user-types'
import { omit } from 'lodash'

@Component({
    name: 'SearchLog',
    components: {
    }
})
export default class extends Vue {
    @Prop({ required: true }) private searchLog!: ISearchLog

    private isEmptySearch(row: any) {
        const searchCondition = omit(row, ['created_at', 'search_type', 'user'])
        let validFields = Object.values(searchCondition).filter(Boolean)
        return !validFields.length
    }
}
